import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import Input from 'yoda-core-components/lib/components/Input/Input';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import IconGreenCheck from 'yoda-core-components/lib/assets/svg/IconGreenCheck.svg';
import Tooltip from 'yoda-core-components/lib/assets/icons/alert/helpIcon2023.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import CheckBoxRounded from '../../assets/images/CheckboxRounded.svg';
import IconTooltip from '../IconTooltip/IconTooltip';
import { normalizePhoneNumber } from '../../common/phoneNumberMask/phoneNumberMask';
import {
    getMaskEligibleInfo,
    isInputDelKeyTriggered,
    getFirstTenDigitOfPhone,
    getInputKeyDownInfo,
    handleCursorPosition,
} from '../../helpers/Utils/Utils';
import regex from '../../common/regex';
import { CREATE_ACCOUNT_INVALID_PHONE_NUMBER } from '../../common/Constants';
import * as styles from './PhoneInput.css';

const cx = classNames.bind(styles);

class PhoneInput extends Component {
    static propTypes = {
        labelValue: PropTypes.string,
        isPhoneValidated: PropTypes.func.isRequired,
        /* eslint react/no-unused-prop-types: 0 */
        emptyInputError: PropTypes.bool,
        value: PropTypes.string,
        placeHolder: PropTypes.string,
        readOnly: PropTypes.bool,
        name: PropTypes.string,
        isEmptyValid: PropTypes.bool,
        showFullWidthLabel: PropTypes.bool,
        isRegexStrict: PropTypes.bool,
        isOnBlurRequired: PropTypes.bool,
        reset: PropTypes.bool,
        clearInputError: PropTypes.bool,
        convertLabelToAnimatingLegend: PropTypes.bool,
        newInfoIcon: PropTypes.bool,
        showTickIcon: PropTypes.bool,
        onKeyPress: PropTypes.func,
        onKeyUp: PropTypes.func,
        resetValue: PropTypes.bool,
        forceInvalid: PropTypes.bool,
        isCartSigninPage: PropTypes.bool,
        validateOnBlur: PropTypes.bool,
        refCallBack: PropTypes.func,
        enableInputFieldMaskFix: PropTypes.oneOfType([PropTypes.array]),
        phoneInputId: PropTypes.string,
        inputClassName: PropTypes.string,
        labelClassName: PropTypes.string,
        inputErrorMessage: PropTypes.string,
        newIconForPersonalInfoAndPreferences: PropTypes.bool,
    };

    static defaultProps = {
        enableInputFieldMaskFix: [],
        emptyInputError: false,
        labelValue: 'Phone Number',
        placeHolder: '',
        value: '',
        readOnly: null,
        name: '',
        isEmptyValid: false,
        showFullWidthLabel: false,
        isRegexStrict: false,
        isOnBlurRequired: false,
        reset: false,
        clearInputError: false,
        convertLabelToAnimatingLegend: false,
        newInfoIcon: false,
        showTickIcon: true,
        onKeyPress: () => {},
        onKeyUp: () => {},
        refCallBack: () => {},
        resetValue: '',
        forceInvalid: false,
        isCartSigninPage: false,
        validateOnBlur: false,
        phoneInputId: 'phone',
        inputClassName: '',
        labelClassName: '',
        inputErrorMessage: '',
        newIconForPersonalInfoAndPreferences: false,
    };

    constructor(props) {
        super(props);
        const { enableInputFieldMaskFix } = this.props;
        const eligibleInfo = getMaskEligibleInfo(
            enableInputFieldMaskFix,
            'phone',
            'tel',
            normalizePhoneNumber(props.value)
        );
        this.state = {
            phoneValue: props.value,
            invalid: false,
            errorMessage: '',
            isValidInput: !!props.value,
            isDeleteKeyEvent: false,
            inputValue: props.value,
            inputKeyEvents: {},
            eligibleInfo,
        };
        this.handleValidation = this.handleValidation.bind(this);
        this.validatePhone = this.validatePhone.bind(this);
        this.setValue = this.setValue.bind(this);
    }

    componentDidMount() {
        // when prepopulating, handleValidation needs to be triggered
        if (this.props.value) this.handleValidation(this.props.value);
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.emptyInputError && this.state.phoneValue === '' && !this.state.invalid) {
            this.setState({
                errorMessage: nextProps.inputErrorMessage || CREATE_ACCOUNT_INVALID_PHONE_NUMBER,
                invalid: true,
            });
        }
        if (nextProps.clearInputError) {
            this.setState({ errorMessage: '', invalid: false });
        }
        if (nextProps.value) {
            this.setState({ isValidInput: !!nextProps.value });
        }
        // update phone number
        if (
            this.state.phoneValue !== nextProps.value &&
            nextProps.value &&
            this.props.value !== nextProps.value
        ) {
            this.setState({ phoneValue: nextProps.value });
        }
        if (nextProps.reset && nextProps.reset !== this.props.reset) {
            this.handleValidation(nextProps.resetValue);
        }
    }

    handleValidation(value) {
        this.setValue(value);
        /* istanbul ignore else */
        if (this.isValidPhoneNumber(value)) {
            let isValid = false;
            const { name } = this.props;
            const unFormatNum = value.replace(regex.createAccount.onlyNum, '');
            // this.animateLabelBasedOnValidation(!!value);
            if (unFormatNum) {
                isValid = this.validatePhone(unFormatNum);
            }

            if (isValid) {
                this.props.isPhoneValidated(true, unFormatNum, name);
            } else {
                this.props.isPhoneValidated(false, unFormatNum, name);
                if (!value && this.props.isEmptyValid) {
                    this.setState({ invalid: false, errorMessage: '' });
                }
            }
        }
    }

    onFocus = () => {
        this.setState({ isValidInput: true });
    };

    onBlur = (value) => {
        this.animateLabelBasedOnValidation(!!value);
        this.props.validateOnBlur && this.handleValidation(value);
        if (this.props.isOnBlurRequired && !value) {
            this.setState({
                invalid: true,
                errorMessage: this.props.inputErrorMessage || CREATE_ACCOUNT_INVALID_PHONE_NUMBER,
            });
        }
    };

    handleOnChange = (phoneNumber) => {
        const { validateOnBlur } = this.props;
        const onChange = validateOnBlur ? this.setValue : this.handleValidation;
        const { inputKeyEvents } = this.state;
        let tempValue = '';
        const { supportInputFieldMask = false, inputType = '' } = inputKeyEvents;
        if (supportInputFieldMask) {
            const isInputDelKeyTriggeredData = isInputDelKeyTriggered(inputType, inputKeyEvents);
            this.setState({ isDeleteKeyEvent: isInputDelKeyTriggeredData });
            if (inputType === 'phone') {
                tempValue = getFirstTenDigitOfPhone(phoneNumber);
            }
            if (isInputDelKeyTriggeredData) {
                this.setState({ inputValue: tempValue });
                return;
            }
        }
        onChange(tempValue, phoneNumber);
    };

    handleBlur = (val, e) => {
        const { target: { value } = {} } = e;
        const { validateOnBlur } = this.props;
        const { inputKeyEvents } = this.state;
        const onChange = validateOnBlur ? this.setValue : this.handleValidation;
        const { supportInputFieldMask = false } = inputKeyEvents;
        if (supportInputFieldMask) {
            this.setState({ isDeleteKeyEvent: false });
            onChange(value, e);
        }

        this.onBlur(value, e);
    };

    handleKeyDown = (e) => {
        const {
            target: { value },
        } = e;
        const {
            eligibleInfo: { enableInputFieldMask },
        } = this.state;
        enableInputFieldMask &&
            this.setState({
                inputKeyEvents: getInputKeyDownInfo(e, true, 'phone'),
            });

        this.props.onKeyPress(value, e);
    };

    handleKeyUp = (e) => {
        const { inputKeyEvents } = this.state;
        const { supportInputFieldMask = false } = inputKeyEvents;
        supportInputFieldMask && handleCursorPosition(e, inputKeyEvents);
        this.props.onKeyUp(e);
    };

    setValue(value) {
        /* istanbul ignore else */
        if (this.isValidPhoneNumber(value)) {
            this.setState({
                phoneValue: value,
            });
        }
    }

    isValidPhoneNumber = (value) => {
        return (
            typeof value !== 'undefined' &&
            value.length <= 14 &&
            regex.createAccount.phoneMask.test(value)
        );
    };

    animateLabelBasedOnValidation = (isValidInput = false) => {
        this.setState({
            isValidInput,
        });
    };

    handleAutoFill = (e) => {
        this.setState({ isValidInput: e.animationName === 'onAutoFillStart' });
    };

    validatePhone(value) {
        const { isRegexStrict } = this.props;

        const regexPhone = isRegexStrict
            ? regex.createAccount.strictPhoneNumber
            : regex.createAccount.phoneNumber;

        if (!regexPhone.test(value)) {
            this.setState({
                errorMessage: this.props.inputErrorMessage || CREATE_ACCOUNT_INVALID_PHONE_NUMBER,
                invalid: true,
            });
            return false;
        }
        this.setState({ errorMessage: '', invalid: false });
        return true;
    }

    render() {
        const val = this.state.isDeleteKeyEvent
            ? this.state.inputValue
            : normalizePhoneNumber()(this.state.phoneValue);
        const phoneLabelClass = this.props.showFullWidthLabel ? 'fullWidthLabel' : '';
        const {
            refCallBack,
            forceInvalid,
            convertLabelToAnimatingLegend,
            readOnly,
            placeHolder,
            inputClassName,
            labelClassName,
        } = this.props;
        const inputElement = (
            <div className={`${cx('phoneInputWrapper')} ${dt(['relative'])}`}>
                <Input
                    id={this.props.phoneInputId}
                    name="phone"
                    type="tel"
                    placeholder={placeHolder}
                    value={val}
                    theme={`${cx(
                        'phoneField',
                        { inputBorderRadius: convertLabelToAnimatingLegend },
                        readOnly ? 'readOnly' : null,
                        this.state.invalid || forceInvalid ? 'errorPhoneField' : null,
                        inputClassName
                    )} ${dt(['!pr-14'])}`}
                    onChange={this.handleOnChange}
                    onKeyDown={this.handleKeyDown}
                    onKeyUp={this.handleKeyUp}
                    onBlur={(valu, event) => this.handleBlur(event.target.value, event)}
                    onFocus={this.onFocus}
                    refCallBack={refCallBack}
                    readOnly={readOnly}
                    datatlPrivate
                    dataQmBlock
                    automationId="phone_number_input"
                    minLength="10"
                    onAnimationStart={this.handleAutoFill}
                />
                {/* eslint-disable-next-line no-nested-ternary */}
                {this.props.newIconForPersonalInfoAndPreferences &&
                this.state.phoneValue !== '' &&
                !this.state.invalid &&
                this.state.phoneValue.replace(regex.createAccount.onlyNum, '').length > 9 ? (
                    <span className={dt(['absolute', 'right-2', 'top-2'])}>
                        <span>
                            <Icon
                                iconType="svg"
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                automationId="at-accPO-icon-green-check"
                            >
                                <CheckBoxRounded />
                            </Icon>
                        </span>
                    </span>
                ) : this.props.newIconForPersonalInfoAndPreferences ? (
                    <IconTooltip
                        message="We'll use this number to look up your Rewards when you shop in JCPenney stores."
                        icon="tooltip"
                        iconComponent={<Tooltip />}
                        iconDetails={{
                            iconWidth: '32px',
                            iconHeight: '32px',
                            iconViewBox: '0 0 32 32',
                        }}
                        id="tooltip"
                        tooltipBodyClassName={cx('phoneTooltip', {
                            forOldInput: !this.props.convertLabelToAnimatingLegend,
                        })}
                        tooltipPlacement="Left"
                        tooltipTextClass={dt(['h-8'])}
                        direction="Topright"
                        theme={dt(['text-left'])}
                    />
                ) : null}
                {!this.props.newIconForPersonalInfoAndPreferences && this.props.newInfoIcon && (
                    <span className={dt(['absolute', 'right-1', 'top-2', 'p-1'])}>
                        <span>
                            <Icon
                                iconType="svg"
                                width="16px"
                                height="16px"
                                viewBox="0 0 24 24"
                                automationId="at-accPO-icon-green-check"
                            >
                                <Tooltip />
                            </Icon>
                        </span>
                    </span>
                )}
                {/* to clear out field on click of 'X' icon */}
                {!this.props.newIconForPersonalInfoAndPreferences &&
                this.props.showTickIcon &&
                this.state.phoneValue !== '' &&
                !this.state.invalid &&
                this.state.phoneValue.replace(regex.createAccount.onlyNum, '').length > 9 ? (
                    <span className={dt(['absolute', 'right-1', 'top-2', 'p-1'])}>
                        <span>
                            <Icon
                                iconType="svg"
                                width="16px"
                                height="16px"
                                viewBox="0 0 24 24"
                                automationId="at-accPO-icon-green-check"
                            >
                                <IconGreenCheck />
                            </Icon>
                        </span>
                    </span>
                ) : null}
                {this.state.invalid && (
                    <span
                        className={dt(['text-error-border', 'text-small', 'block', 'text-left'])}
                        data-automation-id="phone_number_error"
                    >
                        {this.state.errorMessage}
                    </span>
                )}
                {/* {this.state.invalid ?
                    <MessageBox
                        type="error"
                        showIcon={!this.props.isCartSigninPage} theme={cx(this.props.showFullWidthLabel ? 'errorMsgBox' : '', this.props.isCartSigninPage ? 'checkoutRedesignErrorStyle' : '')}
                        contentClassName={cx(this.props.isCartSigninPage ? 'checkoutRedesignErrorContentStyle' : '')}
                        level="inline" title={this.state.errorMessage}
                        automationId="phone_number_error" /> : (<span />)} */}
            </div>
        );
        return (
            <div
                className={`${cx(
                    'phone',
                    this.props.isCartSigninPage ? 'checkoutRedesignStyle' : ''
                )} ${dt(['relative'])}`}
            >
                <div
                    className={`${cx('flexLabel', {
                        invalid:
                            this.props.convertLabelToAnimatingLegend && !this.state.isValidInput,
                        animatingLabel: this.props.convertLabelToAnimatingLegend,
                    })} ${dt(['flex', 'justify-between', 'items-start', 'mb-0'])}`}
                >
                    <label
                        data-automation-id="at-accPO-phoneLabel"
                        htmlFor={this.props.phoneInputId}
                        className={`${cx(
                            'phoneLabel',
                            this.state.isValidInput ? null : labelClassName,
                            this.state.invalid || this.props.forceInvalid ? 'errorLabel' : null,
                            phoneLabelClass,
                            { focusedInput: this.state.isValidInput }
                        )} ${dt([
                            'text-normal',
                            'p-0',
                            'font-open-sans-bold',
                            this.props.showFullWidthLabel ? 'static' : 'absolute',
                            'top-[22px]',
                            'z-[1]',
                        ])}`}
                    >
                        {this.props.labelValue}
                    </label>
                </div>
                {inputElement}
            </div>
        );
    }
}

export default PhoneInput;
